import { useCardPreloadStore } from '../providers/CardPreloadProvider';
import { useMemo } from 'react';
export const useCardSectionRegistry = () => {
  const registry = useCardPreloadStore(store => store.registry);
  const registryLoading = useCardPreloadStore(store => store.registryLoading);
  const result = useMemo(() => {
    return {
      data: registry,
      loading: registryLoading
    };
  }, [registry, registryLoading]);
  return result;
};